import { FC } from "react";
import Styles from "./Spacer.module.css";

const Spacer: FC = () => <div className={Styles.spacer} />;

export default Spacer;
